import { render, staticRenderFns } from "./QuoteLogPanel.vue?vue&type=template&id=2960c55e&scoped=true&"
import script from "./QuoteLogPanel.vue?vue&type=script&lang=js&"
export * from "./QuoteLogPanel.vue?vue&type=script&lang=js&"
import style0 from "./QuoteLogPanel.vue?vue&type=style&index=0&id=2960c55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2960c55e",
  null
  
)

export default component.exports